







import Vue from 'vue';
import DatePicker from '@/components/landing/DatePicker.vue';

export default Vue.extend({
  name: 'BookingDatesModal',
  components: { DatePicker },
  props: {
    minDate: Date,
    maxDate: Date,
    preselectedDate: [String, Object],
  },
  data: () => ({
    isShown: false,
    xPos: null as number | null,
    yPos: null as number | null,
  }),
  mounted() {
    document.addEventListener('touchstart', this.handleTouchStart, false);
    document.addEventListener('touchmove', this.handleTouchMove, false);
  },
  methods: {
    handleTouchStart(evt: TouchEvent): void {
      if (evt.touches && evt.touches.length) {
        this.xPos = evt.touches[0].clientX;
        this.yPos = evt.touches[0].clientY;
      }
    },
    handleTouchMove(evt: TouchEvent): void {
      if (!evt.touches || !evt.touches.length) {
        return;
      }
      if (!this.xPos || !this.yPos) {
        return;
      }
      const xDiff = this.xPos - evt.touches[0].clientX;
      const yDiff = this.yPos - evt.touches[0].clientY;
      if (Math.abs(xDiff) > Math.abs(yDiff)) {
        const el: any = this.$refs.datePickerItem;
        if (el) {
          if (xDiff > 0) {
            el.nextMonth();
          } else {
            el.prevMonth();
          }
        }
      }
      this.xPos = null;
      this.yPos = null;
    },
    onSave(data: any): void {
      this.$emit('onSelectDate', data);
      this.isShown = false;
    },
    onClosed(): void {
      document.removeEventListener('touchstart', this.handleTouchStart, false);
      document.removeEventListener('touchmove', this.handleTouchMove, false);
    },
  },
});
